// Centralized search data for all pages and content
export const searchData = [
  // Main Pages
  {
    id: 'home',
    title: 'Home',
    description: 'Rayad Group - Portfolio of innovative business solutions and services',
    content: 'Welcome to Rayad Group, where innovation meets excellence. We provide comprehensive business solutions across multiple industries including technology, cybersecurity, immigration, education, and more.',
    route: '/',
    category: 'Main',
    keywords: ['home', 'main', 'rayad group', 'portfolio', 'business solutions', 'innovation']
  },
  {
    id: 'about',
    title: 'About',
    description: 'Learn about Rayad Group\'s mission, vision, and values',
    content: 'About Rayad Group - Our story, mission, and the team behind our innovative solutions. Discover how we\'re transforming industries through technology and expertise.',
    route: '/about',
    category: 'Main',
    keywords: ['about', 'company', 'mission', 'vision', 'team', 'story', 'values']
  },
  {
    id: 'portfolio',
    title: 'Portfolio',
    description: 'Explore our diverse portfolio of services and solutions',
    content: 'Our comprehensive portfolio showcases innovative solutions across technology, cybersecurity, education, healthcare, immigration, and business advisory services.',
    route: '/portfolio',
    category: 'Main',
    keywords: ['portfolio', 'services', 'solutions', 'projects', 'showcase']
  },
  {
    id: 'contact',
    title: 'Contact',
    description: 'Get in touch with Rayad Group',
    content: 'Contact Rayad Group for inquiries, partnerships, and business opportunities. We\'re here to help with your project needs.',
    route: '/contact',
    category: 'Main',
    keywords: ['contact', 'inquiries', 'partnerships', 'business', 'get in touch', 'help']
  },

  // Media Pages
  {
    id: 'news',
    title: 'News Articles',
    description: 'Latest news and updates from Rayad Group',
    content: 'Stay updated with the latest news, announcements, and insights from Rayad Group. Read about our recent projects, partnerships, and industry developments.',
    route: '/media/news',
    category: 'Media',
    keywords: ['news', 'articles', 'updates', 'announcements', 'insights', 'developments']
  },
  {
    id: 'videos',
    title: 'Videos',
    description: 'Video content and presentations',
    content: 'Watch our latest video content, presentations, and behind-the-scenes footage. Discover more about our projects and company culture through video.',
    route: '/media/videos',
    category: 'Media',
    keywords: ['videos', 'presentations', 'content', 'footage', 'projects', 'culture']
  },
  {
    id: 'publication-register',
    title: 'Publication Register',
    description: 'The complete 1957–2026 media, social and publication register',
    content: 'Every catalogued link, mention and publication record for Rayad Group and Rayad Kamal Ayub between 1957 and 2026 — press coverage, immigration and advisory milestones, gallery and art activity, corporate and social profiles, archival leads, and the full newswire syndication trail. Searchable and filterable by source, category and year.',
    route: '/media/register',
    category: 'Media',
    keywords: ['register', 'publication', 'media register', 'press', 'archive', 'coverage', 'hyperlinks', 'syndication', 'record', '1957', '2026']
  },

  // Portfolio Services
  {
    id: 'software-development',
    title: 'Software Development',
    description: 'Custom software development services delivering innovative solutions',
    content: 'Our software development team creates cutting-edge applications, web solutions, and custom software tailored to your business needs. We use modern technologies and agile methodologies to deliver high-quality solutions.',
    route: '/portfolio/software-development',
    category: 'Portfolio',
    keywords: ['software', 'development', 'programming', 'applications', 'web', 'custom', 'technology', 'agile', 'coding']
  },
  {
    id: 'cybersecurity',
    title: 'Cyber Security',
    description: 'Advanced cybersecurity solutions with AI and ML-powered intelligence',
    content: 'Next-gen cybersecurity company combining AI-driven intelligence with real-time digital threat detection. We protect against phishing, data leaks, impersonation, and fraud across web, app, and social platforms. Real-time threat monitoring, AI-powered intelligence detection, and comprehensive digital protection.',
    route: '/portfolio/cybersecurity',
    category: 'Portfolio',
    keywords: ['cybersecurity', 'cyber security', 'AI', 'ML', 'threat detection', 'phishing', 'data leaks', 'fraud', 'protection', 'intelligence', 'security', 'digital threats']
  },
  {
    id: 'blockchain-crypto',
    title: 'Blockchain and Crypto',
    description: 'Advanced blockchain technologies and cryptocurrency trading solutions',
    content: 'Comprehensive blockchain and cryptocurrency solutions including trading platforms, DeFi applications, smart contracts, and blockchain consulting. We help businesses leverage blockchain technology for secure, transparent, and efficient operations.',
    route: '/portfolio/blockchain-seed-investment',
    category: 'Portfolio',
    keywords: ['blockchain', 'cryptocurrency', 'crypto', 'trading', 'DeFi', 'smart contracts', 'bitcoin', 'ethereum', 'investment', 'digital assets']
  },
  {
    id: 'intrusion-detection',
    title: 'Electronic Intrusion Detection',
    description: 'Advanced electronic intrusion detection sensors and monitoring systems',
    content: 'State-of-the-art electronic intrusion detection systems providing comprehensive security monitoring. Our solutions include advanced sensors, real-time alerts, and integrated monitoring platforms for maximum protection.',
    route: '/portfolio/intrusion-detection',
    category: 'Portfolio',
    keywords: ['intrusion detection', 'security systems', 'sensors', 'monitoring', 'alerts', 'electronic security', 'surveillance', 'protection']
  },
  {
    id: 'education',
    title: 'Techucation',
    description: 'Educational technology solutions combining traditional learning with modern tools',
    content: 'Innovative educational technology solutions that bridge traditional learning methods with cutting-edge digital tools. We create engaging learning platforms, educational apps, and training systems for enhanced learning experiences.',
    route: '/portfolio/education',
    category: 'Portfolio',
    keywords: ['education', 'techucation', 'learning', 'educational technology', 'e-learning', 'training', 'digital learning', 'platforms', 'apps']
  },
  {
    id: 'biotech',
    title: 'Biotech & Longevity',
    description: 'Biotechnology and longevity research solutions',
    content: 'Advanced biotechnology solutions focusing on longevity research, health optimization, and life extension technologies. We develop innovative approaches to healthcare, aging research, and biotechnological applications.',
    route: '/portfolio/biotech',
    category: 'Portfolio',
    keywords: ['biotech', 'biotechnology', 'longevity', 'health', 'life extension', 'research', 'healthcare', 'aging', 'medical technology']
  },
  {
    id: 'immigration',
    title: 'Immigration Services',
    description: 'Comprehensive immigration consulting and legal services',
    content: 'Expert immigration services providing comprehensive consultation, legal assistance, and guidance for visa applications, permanent residency, citizenship, and immigration law matters. We help individuals and families navigate complex immigration processes.',
    route: '/portfolio/immigration',
    category: 'Portfolio',
    keywords: ['immigration', 'visa', 'legal services', 'consultation', 'residency', 'citizenship', 'law', 'guidance', 'applications']
  },
  {
    id: 'corporate-services',
    title: 'Corporate Services',
    description: 'Professional corporate services and business solutions',
    content: 'Comprehensive corporate services including business formation, compliance, corporate governance, and professional consulting. We help businesses establish, grow, and maintain their corporate structure effectively.',
    route: '/portfolio/corporate-services',
    category: 'Portfolio',
    keywords: ['corporate services', 'business formation', 'compliance', 'governance', 'consulting', 'professional services', 'corporate structure']
  },
  {
    id: 'business-advisory',
    title: 'Business Advisory',
    description: 'Strategic business advisory and financial consulting services',
    content: 'Expert business advisory services providing strategic planning, financial consulting, market analysis, and growth strategies. We help businesses make informed decisions and achieve sustainable growth.',
    route: '/portfolio/business-financial-advisory',
    category: 'Portfolio',
    keywords: ['business advisory', 'financial consulting', 'strategic planning', 'market analysis', 'growth strategies', 'consulting', 'business planning']
  },
  {
    id: 'art-gallery',
    title: 'Contemporary Art Gallery',
    description: 'MRK Contemporary Art Gallery showcasing modern artistic works',
    content: 'MRK Contemporary Art Gallery features cutting-edge contemporary art, modern sculptures, paintings, and digital art installations. We promote emerging and established artists in the contemporary art scene.',
    route: '/mrk-art-gallery',
    category: 'Portfolio',
    alternateRoute: '/portfolio/art',
    keywords: ['art gallery', 'contemporary art', 'modern art', 'sculptures', 'paintings', 'digital art', 'exhibitions', 'artists', 'MRK']
  }
];

// Function to get all searchable content
export const getAllSearchableContent = () => {
  return searchData;
};

// Function to get content by category
export const getContentByCategory = (category) => {
  return searchData.filter(item => item.category === category);
};

// Function to get content by route
export const getContentByRoute = (route) => {
  return searchData.find(item => item.route === route || item.alternateRoute === route);
};

// Categories for filtering
export const searchCategories = {
  'Main': 'Main Pages',
  'Portfolio': 'Portfolio Services', 
  'Media': 'Media Content'
};